import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  size?: 'lg' | 'sm';
};
export function CtaButton({
  children,
  href = '#pricing',
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-9 py-4 text-sm sm:text-base rounded-full' : 'px-6 py-3 text-xs sm:text-sm rounded-full';
  return <a href={href} className={`group inline-flex items-center justify-center gap-2.5 bg-action hover:bg-action-dark text-ink font-bold uppercase tracking-[0.14em] shadow-card hover:shadow-lift transition-colors duration-200 focus:outline-none focus-visible:ring-4 focus-visible:ring-action/40 ${sizing} ${className}`} data-id="element-120" data-mp="qj910o3fjt5u">
      {children}
      <ArrowRightIcon className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-121" data-mp="19as5kzd3rf9z" />
    </a>;
}